// @vendors
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// @styles
import './App.css';

// @pages
import LandingPage from './pages/home/LandingPage';
import ChatPage from './pages/chat/ChatPage';
import CategorySelection from './pages/onboarding/CategorySelection';
import ServiceSelection from './pages/onboarding/ServiceSelection';
import ProfileDocuments from './pages/onboarding/ProfileDocuments';
import CompanyDetails from './pages/onboarding/CompanyDetails';
import CompanyHistory from './pages/onboarding/CompanyHistory';
import LocationSelection from './pages/onboarding/LocationSelection';
import LeadPriceSelection from './pages/onboarding/LeadPriceSelection';
import TermsConditions from './pages/onboarding/TermsConditions';
import Congratulations from './pages/onboarding/Congratulations';
import CompanyDashboard from './pages/dashboard/CompanyDashboard';
import InmobiliariaDashboard from './pages/dashboard/InmobiliariaDashboard';
import PromotionsManagement from './pages/dashboard/PromotionsManagement';
import CompanySubscription from './pages/dashboard/components/CompanySubscription';

// @contexts
import { ThemeProvider } from './context/ThemeContext';
import { OnboardingProvider } from './context/OnboardingContext';
import { AuthProvider } from './context/AuthContext';
import { WhatsAppProvider } from './context/WhatsAppContext';
import { PathRoutes } from './components/routes/PathRoutes';

function App() {

  return (
    <ThemeProvider>
      <AuthProvider>
        <WhatsAppProvider>
          <OnboardingProvider>
            <Toaster
              position="top-center"
              reverseOrder={false}
              gutter={8}
              containerClassName=""
              containerStyle={{}}
              toasterId="default"
              toastOptions={{
                className: '',
                duration: 3000,
                removeDelay: 1000,
                style: {
                  background: '#363636',
                  color: '#fff',
                  minWidth: '200px',
                  maxWidth: '400px',
                },
              }}
            />
            <Router>
              <Routes>
                <Route path={PathRoutes.home} element={<LandingPage />} />
                <Route path="/chat" element={<ChatPage />} />
                {/* Ruta del dashboard de empresa */}
                <Route path={PathRoutes.dashboard} element={<CompanyDashboard />} />
                <Route path={PathRoutes.suscription} element={<CompanySubscription />} />
                <Route path={PathRoutes.inmobiliaria} element={<InmobiliariaDashboard />} />
                <Route path={PathRoutes.companyPartner} element={<InmobiliariaDashboard />} />
                <Route path={PathRoutes.userAdminUnit} element={<InmobiliariaDashboard />} />
                {/* Ruta de gestión de promociones */}
                <Route path={PathRoutes.promotions} element={<PromotionsManagement />} />
                {/* Rutas de onboarding */}
                <Route path="/onboarding/category" element={<CategorySelection />} />
                <Route path="/onboarding/services" element={<ServiceSelection />} />
                <Route path="/onboarding/profile-documents" element={<ProfileDocuments />} />
                <Route path="/onboarding/company-details" element={<CompanyDetails />} />
                <Route path="/onboarding/company-history" element={<CompanyHistory />} />
                <Route path="/onboarding/locations" element={<LocationSelection />} />
                <Route path="/onboarding/lead-price" element={<LeadPriceSelection />} />
                <Route path="/onboarding/terms" element={<TermsConditions />} />
                <Route path="/onboarding/congratulations" element={<Congratulations />} />
                <Route path="*" element={<LandingPage />} />

              </Routes>
            </Router>
          </OnboardingProvider>
        </WhatsAppProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
